import actionTypes from './actionTypes';

const INITIAL_STATE = {
  deductionInvoicesLoading: false,
  deductionInvoicesFailed: false,
  deductionInvoicesError: false,
  deductionInvoicesMessage: null,
  deductionInvoicesList: [],
  deductionInvoices: {},

  deductionDeletedsInvoicesLoading: false,
  deductionDeletedsInvoicesFailed: false,
  deductionDeletedsInvoicesError: false,
  deductionDeletedsInvoicesMessage: null,
  deductionDeletedsInvoicesList: [],
  deductionDeletedsInvoices: {},

  newDeductionInvoiceLoading: false,
  newDeductionInvoiceFailed: false,
  newDeductionInvoiceError: false,
  newDeductionInvoiceMessage: null,
  newDeductionInvoiceList: [],
  newDeductionInvoice: {},

  changeDeductionInvoiceStatusLoading: false,
  changeDeductionInvoiceStatusFailed: false,
  changeDeductionInvoiceStatusError: false,
  changeDeductionInvoiceStatusMessage: null,

  deleteDeductionInvoiceLoading: false,
  deleteDeductionInvoiceFailed: false,
  deleteDeductionInvoiceError: false,
  deleteDeductionInvoiceMessage: null,
  deleteDeductionInvoiceList: [],
  deleteDeductionInvoice: {}
};

function invoiceDeductionsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actionTypes.FETCH_ALL_DEDUCTION_INVOICES_LOADING: {
      return {
        ...state,
        deductionInvoicesLoading: true,
        deductionInvoicesFailed: false,
        deductionInvoicesError: false,
        deductionInvoicesMessage: null,
        deductionInvoicesList: [],
        deductionInvoices: {}
      };
    }
    case actionTypes.FETCH_ALL_DEDUCTION_INVOICES_SUCCESS: {
      return {
        ...state,
        deductionInvoicesLoading: false,
        deductionInvoicesFailed: false,
        deductionInvoicesError: false,
        deductionInvoicesMessage: null,
        deductionInvoicesList: [...action.payload.cafeFactorDeductions],
        deductionInvoices: { ...action.payload }
      };
    }
    case actionTypes.FETCH_ALL_DEDUCTION_INVOICES_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        deductionInvoicesLoading: false,
        deductionInvoicesFailed: true,
        deductionInvoicesError: false,
        deductionInvoicesMessage: message,
        deductionInvoicesList: [],
        deductionInvoices: {}
      };
    }
    case actionTypes.FETCH_ALL_DEDUCTION_INVOICES_REJECT: {
      return {
        ...state,
        deductionInvoicesLoading: false,
        deductionInvoicesFailed: false,
        deductionInvoicesError: true,
        deductionInvoicesMessage: null,
        deductionInvoicesList: [],
        deductionInvoices: {}
      };
    }

    case actionTypes.INSERT_NEW_DEDUCTION_INVOICE_LOADING: {
      return {
        ...state,
        newDeductionInvoiceLoading: true,
        newDeductionInvoiceFailed: false,
        newDeductionInvoiceError: false,
        newDeductionInvoiceMessage: null,
        newDeductionInvoiceList: [],
        newDeductionInvoice: {}
      };
    }
    case actionTypes.INSERT_NEW_DEDUCTION_INVOICE_SUCCESS: {
      return {
        ...state,
        newDeductionInvoiceLoading: false,
        newDeductionInvoiceFailed: false,
        newDeductionInvoiceError: false,
        newDeductionInvoiceMessage: null,
        newDeductionInvoice: { ...action.payload }
      };
    }
    case actionTypes.INSERT_NEW_DEDUCTION_INVOICE_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        newDeductionInvoiceLoading: false,
        newDeductionInvoiceFailed: true,
        newDeductionInvoiceError: false,
        newDeductionInvoiceMessage: message,
        newDeductionInvoiceList: [],
        newDeductionInvoice: {}
      };
    }
    case actionTypes.INSERT_NEW_DEDUCTION_INVOICE_REJECT: {
      return {
        ...state,
        newDeductionInvoiceLoading: false,
        newDeductionInvoiceFailed: false,
        newDeductionInvoiceError: true,
        newDeductionInvoiceMessage: null,
        newDeductionInvoiceList: [],
        newDeductionInvoice: {}
      };
    }

    case actionTypes.FETCH_ALL_DEDUCTIONS_DELETEDS_LOADING: {
      return {
        ...state,
        deductionDeletedsInvoicesLoading: true,
        deductionDeletedsInvoicesFailed: false,
        deductionDeletedsInvoicesError: false,
        deductionDeletedsInvoicesMessage: null,
        deductionDeletedsInvoicesList: [],
        deductionDeletedsInvoices: {}
      };
    }
    case actionTypes.FETCH_ALL_DEDUCTIONS_DELETEDS_SUCCESS: {
      return {
        ...state,
        deductionDeletedsInvoicesLoading: false,
        deductionDeletedsInvoicesFailed: false,
        deductionDeletedsInvoicesError: false,
        deductionDeletedsInvoicesMessage: null,
        deductionDeletedsInvoicesList: [...action.payload.cafeFactorDeductions],
        deductionDeletedsInvoices: { ...action.payload }
      };
    }
    case actionTypes.FETCH_ALL_DEDUCTIONS_DELETEDS_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        deductionDeletedsInvoicesLoading: false,
        deductionDeletedsInvoicesFailed: true,
        deductionDeletedsInvoicesError: false,
        deductionDeletedsInvoicesMessage: message,
        deductionDeletedsInvoicesList: [],
        deductionDeletedsInvoices: {}
      };
    }
    case actionTypes.FETCH_ALL_DEDUCTIONS_DELETEDS_REJECT: {
      return {
        ...state,
        deductionDeletedsInvoicesLoading: false,
        deductionDeletedsInvoicesFailed: false,
        deductionDeletedsInvoicesError: true,
        deductionDeletedsInvoicesMessage: null,
        deductionDeletedsInvoicesList: [],
        deductionDeletedsInvoices: {}
      };
    }

    case actionTypes.CHANGE_DEDUCTION_INVOICE_STATUS_LOADING: {
      return {
        ...state,
        changeDeductionInvoiceStatusLoading: true,
        changeDeductionInvoiceStatusFailed: false,
        changeDeductionInvoiceStatusError: false,
        changeDeductionInvoiceStatusMessage: null
      };
    }
    case actionTypes.CHANGE_DEDUCTION_INVOICE_STATUS_SUCCESS: {
      return {
        ...state,
        changeDeductionInvoiceStatusLoading: false,
        changeDeductionInvoiceStatusFailed: false,
        changeDeductionInvoiceStatusError: false,
        changeDeductionInvoiceStatusMessage: null
      };
    }
    case actionTypes.CHANGE_DEDUCTION_INVOICE_STATUS_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        changeDeductionInvoiceStatusLoading: false,
        changeDeductionInvoiceStatusFailed: true,
        changeDeductionInvoiceStatusError: false,
        changeDeductionInvoiceStatusMessage: message
      };
    }
    case actionTypes.CHANGE_DEDUCTION_INVOICE_STATUS_REJECT: {
      return {
        ...state,
        changeDeductionInvoiceStatusLoading: false,
        changeDeductionInvoiceStatusFailed: false,
        changeDeductionInvoiceStatusError: true,
        changeDeductionInvoiceStatusMessage: null
      };
    }

    case actionTypes.DELETE_DEDUCTION_INVOICE_LOADING: {
      return {
        ...state,
        deleteDeductionInvoiceLoading: true,
        deleteDeductionInvoiceFailed: false,
        deleteDeductionInvoiceError: false,
        deleteDeductionInvoiceMessage: null,
        deleteDeductionInvoiceList: [],
        deleteDeductionInvoice: {}
      };
    }
    case actionTypes.DELETE_DEDUCTION_INVOICE_SUCCESS: {
      return {
        ...state,
        deleteDeductionInvoiceLoading: false,
        deleteDeductionInvoiceFailed: false,
        deleteDeductionInvoiceError: false,
        deleteDeductionInvoiceMessage: null,
        deleteDeductionInvoice: { ...action.payload }
      };
    }
    case actionTypes.DELETE_DEDUCTION_INVOICE_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        deleteDeductionInvoiceLoading: false,
        deleteDeductionInvoiceFailed: true,
        deleteDeductionInvoiceError: false,
        deleteDeductionInvoiceMessage: message,
        deleteDeductionInvoiceList: [],
        deleteDeductionInvoice: {}
      };
    }
    case actionTypes.DELETE_DEDUCTION_INVOICE_REJECT: {
      return {
        ...state,
        deleteDeductionInvoiceLoading: false,
        deleteDeductionInvoiceFailed: false,
        deleteDeductionInvoiceError: true,
        deleteDeductionInvoiceMessage: null,
        deleteDeductionInvoiceList: [],
        deleteDeductionInvoice: {}
      };
    }

    default:
      return state;
  }
}

export default invoiceDeductionsReducer;
